import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  getThirdPartyOrdersListUrl,
  GET_ACCOUNT_THIRD_PARTY_ORDER_LIST,
  headers,
  GET_ACCOUNT_THIRD_PARTY_ORDER_DETAILS,
  getThirdPartyOrdersDetailsUrl,
  insertUpdateThirdPartyVendorOrderDtlUrl,
  IU_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS,
  getThirdPartyVendorOrdersDetailsUrl,
  GET_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS,
} from "../../utils/constants";
import moment from "moment";

export const getThirdPartyOrdersList_action =
  (OrderNo, fromDate, toDate, ServiceName, VendorName) =>
  async (dispatch) => {
    try {
      const mapdata = {
        UserID: sessionStorage.getItem("userId"),
        OrderNo: OrderNo,
        Fromdate: fromDate,
        ToDate: toDate,
        ServiceName: ServiceName,
        VendorName: VendorName,
      };

      console.log("accountReciept mapdata...", mapdata);
      const res = await axiosGet(getThirdPartyOrdersListUrl, mapdata, headers);
      dispatch({
        type: GET_ACCOUNT_THIRD_PARTY_ORDER_LIST,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const thirdParty_detail_action =
  (OrderID, ServiceID, VendorID) => async (dispatch) => {
    try {
      const params = {
        userId: sessionStorage.getItem("userId"),
        OrderID: OrderID,
        ServiceID: ServiceID,
        VendorID: VendorID,
      };
      console.log("Third Party detail mapdata...", params);
      const res = await axiosGet(
        getThirdPartyOrdersDetailsUrl,
        params,
        headers
      );
      console.log("detailsThirdPart", res);
      dispatch({
        type: GET_ACCOUNT_THIRD_PARTY_ORDER_DETAILS,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const thirdParty_VendorOrder_detail_action =
  (OrderID, ServiceID, VendorID) => async (dispatch) => {
    try {
      const params = {
        OrderID: OrderID,
        ServiceID: ServiceID,
        VendorID: VendorID,
      };
      console.log("Third Party Vendor Order detail mapdata...", params);
      const res = await axiosGet(
        getThirdPartyVendorOrdersDetailsUrl,
        params,
        headers
      );
      console.log("detailsThirdPart", res);
      dispatch({
        type: GET_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const insertUpdate_thirdParty_vendorOrderDtl_action =
  (
    OrderNo,
    ClientName,
    ClientEmail,
    VendorCompany,
    VendorEmail,
    BookingDate,
    VendorOrderDtlID,
    OrderDtlID,
    ServiceID,
    VendorServicePackageID,
    FinalAmount,
    AdditionalAmount,
    IsOrderAcceptedbyVendor,
    IsOrderAcceptedbyClient,
    IsQuotationSubmitted,
    IsQuotationApproved,
    IsInvoiceSubmitted,
    IsPaymentReceived,
    IsFinalInvoiceSubmitted,
    FinalPaymentReceived,
    quotationFilePath,
    quotationFileName,
    quotationFileType,
    quotationFormFile,
    invoiceFilePath,
    invoiceFileName,
    invoiceFileType,
    invoiceFormFile,
    recieptFilePath,
    recieptFileName,
    recieptFileType,
    recieptFormFile,
    additionalInvoiceFilePath,
    additionalInvoiceFileName,
    additionalInvoiceFileType,
    additionalInvoiceFormFile,
    additionalReceiptFilePath,
    additionalReceiptFileName,
    additionalReceiptFileType,
    additionalReceiptFormFile,
    OrderID,
    VendorID,
    NodeMailFlag,
    clientAcceptSignaturePath,
    OrderAcceptedbyClientContact,ServiceName
  ) =>
  async (dispatch) => {
    console.log(VendorOrderDtlID, "beforMapData");
    try {
      const mapdata = {
        userId: parseInt(sessionStorage.getItem("userId")),
        OrderNo: OrderNo != "" ? OrderNo : null,
        ClientName: ClientName != "" ? ClientName : null,
        ClientEmail: ClientEmail != "" ? ClientEmail : null,
        VendorCompany: VendorCompany != "" ? VendorCompany : null,
        VendorEmail: VendorEmail != "" ? VendorEmail : null,
        BookingDate: BookingDate != "" ? BookingDate : null,
        VendorOrderDtlID: VendorOrderDtlID != "" ? VendorOrderDtlID : null,
        OrderDtlID: OrderDtlID != "" ? OrderDtlID : null,
        ServiceID: ServiceID != "" ? ServiceID : null,
        VendorServicePackageID:
          VendorServicePackageID != "" ? VendorServicePackageID : null,
        FinalAmount: FinalAmount != "" ? FinalAmount : null,
        AdditionalAmount: AdditionalAmount != "" ? AdditionalAmount : null,
        IsOrderAcceptedbyVendor:
          IsOrderAcceptedbyVendor != "" ? IsOrderAcceptedbyVendor : null,
        IsOrderAcceptedbyClient:
          IsOrderAcceptedbyClient != "" ? IsOrderAcceptedbyClient : null,
        IsQuotationSubmitted:
          IsQuotationSubmitted != "" ? IsQuotationSubmitted : null,
        IsQuotationApproved:
          IsQuotationApproved != "" ? IsQuotationApproved : null,
        IsInvoiceSubmitted:
          IsInvoiceSubmitted != "" ? IsInvoiceSubmitted : null,
        IsPaymentReceived: IsPaymentReceived != "" ? IsPaymentReceived : null,
        IsFinalInvoiceSubmitted:
          IsFinalInvoiceSubmitted != "" ? IsFinalInvoiceSubmitted : null,
        FinalPaymentReceived:
          FinalPaymentReceived != "" ? FinalPaymentReceived : null,
        quotationFilePath: quotationFilePath != "" ? quotationFilePath : null,
        quotationFileName: quotationFileName != "" ? quotationFileName : null,
        quotationFileType: quotationFileType != "" ? quotationFileType : null,
        quotationFormFile: quotationFormFile != "" ? quotationFormFile : null,
        invoiceFilePath: invoiceFilePath != "" ? invoiceFilePath : null,
        invoiceFileName: invoiceFileName != "" ? invoiceFileName : null,
        invoiceFileType: invoiceFileType != "" ? invoiceFileType : null,
        invoiceFormFile: invoiceFormFile != "" ? invoiceFormFile : null,
        recieptFilePath: recieptFilePath != "" ? recieptFilePath : null,
        recieptFileName: recieptFileName != "" ? recieptFileName : null,
        recieptFileType: recieptFileType != "" ? recieptFileType : null,
        recieptFormFile: recieptFormFile != "" ? recieptFormFile : null,
        additionalInvoiceFilePath:
          additionalInvoiceFilePath != "" ? additionalInvoiceFilePath : null,
        additionalInvoiceFileName:
          additionalInvoiceFileName != "" ? additionalInvoiceFileName : null,
        additionalInvoiceFileType:
          additionalInvoiceFileType != "" ? additionalInvoiceFileType : null,
        additionalInvoiceFormFile:
          additionalInvoiceFormFile != "" ? additionalInvoiceFormFile : null,
        additionalReceiptFilePath:
          additionalReceiptFilePath != "" ? additionalReceiptFilePath : null,
        additionalReceiptFileName:
          additionalReceiptFileName != "" ? additionalReceiptFileName : null,
        additionalReceiptFileType:
          additionalReceiptFileType != "" ? additionalReceiptFileType : null,
        additionalReceiptFormFile:
          additionalReceiptFormFile != "" ? additionalReceiptFormFile : null,
        VendorID: VendorID != "" ? VendorID : null,
        OrderID: OrderID != "" ? OrderID : null,
        NodeMailFlag: NodeMailFlag != "" ? NodeMailFlag : null,
        clientAcceptSignaturePath:
          clientAcceptSignaturePath != "" ? clientAcceptSignaturePath : null,
        OrderAcceptedbyClientContact:
          OrderAcceptedbyClientContact != ""
            ? OrderAcceptedbyClientContact
            : null,
            ServiceName:ServiceName
      };
      console.log("third party vendor order details add mapdata...", mapdata);

      const res = await axiosPost(
        insertUpdateThirdPartyVendorOrderDtlUrl,
        mapdata,
        headers
      );
      dispatch({
        type: IU_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
